import i18n from '../../../../locales/index'
import TagsNav from './tags-nav.vue'
export default TagsNav
